module.exports = __webpack_public_path__ + "assets/52045fac0dbae4f181f229cc0c2e2978.mp3";